import { Component, ElementRef, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import {
  customDecode,
  customDecrypt,
  customEncode,
  customEncrypt,
  decrypt,
  encrypt,
  greaterThanZeroValidator,
  noWhitespaceValidator,
  nonNegativeValidator,
} from '@piqet-angular/data';
import { ProjectsService } from 'libs/data/src/lib/services/projects/projects.service';
import { ToastrService } from 'ngx-toastr';
import { ViewportScroller } from '@angular/common';
import { ProjectsFacade } from '@piqet-angular/data';
import { SharedService } from 'libs/data/src/lib/services/shared/shared.service';
import { SwalService } from 'libs/shared/src/lib/service/swal.service';
import {
  AccessPermissionService,
  FileUploadComponent,
  FileUploadResult,
} from '@piqet-angular/shared';
@Component({
  selector: 'piqet-angular-product-configuration',
  templateUrl: './product-configuration.component.html',
  styleUrls: ['./product-configuration.component.scss'],
})
export class ProductConfigurationComponent {
  selectedCurrency: any;
  currencyList: any;
  showCurrencyList: any;
  productProjectForm!: FormGroup;
  productProjectData: any;
  countryList: any;
  // File upload properties
  selectedFiles: string | null = null;
  imageUrl: string | null = null;
  fileBase64: string | null = null;
  existingFileName: string | null = null;

  iserror = false;
  selectedCountry: any;
  selectedUnit: any;
  productId: any;
  productImage: any;
  productScope: any;
  checkBoxValidation: boolean = false;
  productSelected: any;
  saveCheckboxList: any;
  allProductConfigurationData: any;
  submitted: boolean = false;
  unitId: any;
  activatedRoute: any;
  menuDataForRouting: any = [];
  nextRouteName: any;
  isCostTurnedOff: any;
  currencyItem: any;
  showEdit: boolean = false;
  productConfigId: any;

  isProductManufacturingDataDelete = false;
  isProductUseDataDelete = false;
  isProductEOLDataDelete = false;

  confirmedDeletes: {
    manufacturing: boolean;
    productUse: boolean;
    eol: boolean;
  } = {
    manufacturing: false,
    productUse: false,
    eol: false,
  };

  @ViewChild('fileUploadComponent') fileUploadComponent!: FileUploadComponent;
  constructor(
    private readonly formBuilder: FormBuilder,
    private readonly projectService: ProjectsService,
    private readonly router: Router,
    private readonly toaster: ToastrService,
    private readonly viewportScroller: ViewportScroller,
    private readonly projectFacade: ProjectsFacade,
    private readonly accessService: AccessPermissionService,
    private readonly sharedService: SharedService,
    private readonly route: ActivatedRoute,
    private readonly swalService: SwalService
  ) {
    this.activatedRoute = this.route.snapshot.routeConfig?.path;
    this.route.queryParams.subscribe(async (values: any) => {
      const url = location.href.split('/');
      this.productConfigId = Number(atob(decodeURIComponent(customDecode(url[6]))));
      const productId = customDecrypt(this.route.snapshot.queryParams['param']);
      this.productId = Number(productId.id);
      this.imageUrl = '';
      this.checkBoxValidation = false;
      this.removeImage();
      this.setFormData();
    });
    this.sharedService.productProjectMenuArrData$.subscribe((res: any) => {
      if (res?.length) {
        this.menuDataForRouting = res.flatMap((product: any) =>
          product.submenu.map((scope: any) => ({
            ...scope,
            productId: product.productId,
            productName: product.name,
          }))
        );
      }
    });
  }

  async ngOnInit() {
    this.showEdit = this.accessService.hasPermission('edit', this.activatedRoute);
    this.viewportScroller.scrollToPosition([0, 0]);
    this.productProjectForm = this.formBuilder.group({
      productName: ['', [Validators.required, noWhitespaceValidator, Validators.maxLength(50)]],
      productNameReport: [
        '',
        [Validators.required, noWhitespaceValidator, Validators.maxLength(15)],
      ],
      country: [null, Validators.required],
      description: [null],
      amount: [null, [nonNegativeValidator, Validators.required, Validators.maxLength(50)]],
      density: [1, [Validators.required, greaterThanZeroValidator(), Validators.maxLength(50)]],
      unit: [null, [Validators.required]],
      currency: [null],
    });
  }
  get formControls() {
    return this.productProjectForm.controls;
  }
  async mapCountryList() {
    await this.allProductConfigurationData?.countryItems.map((item: any) => {
      if (item.id == this.allProductConfigurationData.countryId) {
        return (this.selectedCountry = item);
      }
    });
  }

  async setUnit() {
    await this.allProductConfigurationData?.unitList?.map((item: any) => {
      if (item.id == this.allProductConfigurationData?.unitId) {
        return (this.selectedUnit = item);
      }
    });
  }

  async setFormData() {
    this.allProductConfigurationData = await this.longRunningMethod();
    // Store delete flags from backend
    this.isProductManufacturingDataDelete =
      this.allProductConfigurationData?.isProductManufacturingData ?? false;
    this.isProductUseDataDelete = this.allProductConfigurationData?.isProductUseData ?? false;
    this.isProductEOLDataDelete = this.allProductConfigurationData?.isProductEOLData ?? false;
    this.projectFacade.storeProjectNameForBreadcrumb(this.allProductConfigurationData.name);
    await this.mapCountryList();
    await this.setUnit();
    this.countryList = this.allProductConfigurationData?.countryItems;
    this.productImage = this.allProductConfigurationData?.productImage;
    const urlParts = this.productImage?.split('/');
    if (urlParts) {
      const fileName = urlParts[urlParts?.length - 1];
      this.existingFileName = fileName ? fileName : null;
      this.selectedFiles = fileName ? fileName : null;
    }
    this.productScope = this.allProductConfigurationData?.productScopesAll;
    this.productSelected = this.allProductConfigurationData?.productScopesSelected;
    this.setCheckbox();
    this.currencyList = this.allProductConfigurationData?.currencyItems;
    this.isCostTurnedOff = !this.allProductConfigurationData?.isTurnOffCost;
    this.showCurrencyList = !this.isCostTurnedOff ? false : true;
    this.setCurrency();
    this.productProjectForm.patchValue({
      productName: this.allProductConfigurationData.name,
      productNameReport: this.allProductConfigurationData.shortProductName,
      country: this.selectedCountry,
      categoryJustification: this.allProductConfigurationData.impectCategoryJustification,
      otherLimitations: this.allProductConfigurationData.otherAssumptionsOrLimitation,
      boundryJustification: this.allProductConfigurationData.systemBoundaryJustification,
      amount: this.allProductConfigurationData?.amountOfproduct,
      density: this.allProductConfigurationData?.densityOfProduct,
      unit: this.selectedUnit,
      description: this.allProductConfigurationData?.description,
      currency: this.currencyItem,
    });
  }

  async longRunningMethod() {
    const response = await this.projectService.getMyAllProductProjectModalEditData(
      this.productConfigId,
      true,
      this.productId
    );
    return response.data;
  }

  setCheckbox() {
    this.productScope.forEach((ele: any) => {
      const a = this.productSelected.find((y: any) => ele.scopeId == y.scopeId);
      if (a) {
        ele.checked = true;
        ele.productId = a.productId;
        ele.scopeId = a.scopeId;
        ele.id = a.id;
      }
    });
    this.sharedService.productSidebar.next(this.productScope);
  }

  async setCurrency() {
    await this.currencyList?.map((data: any) => {
      if (data?.id == this.allProductConfigurationData?.currencyId) {
        return (this.currencyItem = data);
      }
    });
  }

  changeUnit(eve: any) {
    this.unitId = eve?.id;
  }

  removeProductImage() {
    this.projectService.removeProductImage(this.productId).subscribe((res: any) => {
      if (res.messageType) {
        this.toaster.error(res.message);
      } else {
        this.toaster.success(res.message);
        this.imageUrl = null;
        this.productImage = '';
        this.existingFileName = null;
        this.selectedFiles = null;

        // Reset the file upload component
        if (this.fileUploadComponent) {
          this.fileUploadComponent.reset();
        }
      }
    });
  }

  deleteConfirmation() {
    this.swalService
      .confirm(
        'Are you sure?',
        'Do you really want to delete this image? This process cannot be undone.'
      )
      .then(confirmed => {
        if (confirmed) {
          this.removeProductImage();
        }
      });
  }

  saveData(data: any, productName?: any) {
    this.submitted = true;
    if (data instanceof Event) {
      const target = data.target as HTMLInputElement;
      data = { value: target.value };
    }
    if (productName == 'isDrpDwn' && !data?.id) return;
    if (productName === 'productName' && this.productProjectForm.controls['productName'].valid) {
      this.productProjectForm.controls['productNameReport'].setValue(data.value.slice(0, 15));
    }
    if (this.productProjectForm.valid) {
      const payload = {
        productId: this.productId,
        name: this.productProjectForm.controls['productName'].value,
        shortProductName: this.productProjectForm.controls['productNameReport'].value,
        countryId: this.productProjectForm.controls['country'].value?.id,
        productContentsFile: this.selectedFiles,
        productContentsImage: this.fileBase64,
        description: this.productProjectForm.controls['description'].value,
        amountOfproduct: this.productProjectForm.controls['amount'].value,
        densityOfProduct: this.productProjectForm.controls['density'].value,
        unitId:
          this.productProjectForm.controls['unit'].value?.id ||
          this.allProductConfigurationData?.unitId,
        productScopesSelected:
          this.saveCheckboxList || this.allProductConfigurationData.productScopesSelected,
        currencyId: this.showCurrencyList
          ? this.productProjectForm.controls['currency'].value?.id
          : 1, // DEFAULT SHOULD ALWAYS BE US
        isTurnOffCost: !this.isCostTurnedOff,
        isProductManufacturingDataDelete: this.confirmedDeletes.manufacturing,
        isProductUseDataDelete: this.confirmedDeletes.productUse,
        isProductEOLDataDelete: this.confirmedDeletes.eol,
        productConfigId: this.productConfigId,
      };
      this.projectService.editProjectProductIngredient(payload).subscribe((res: any) => {
        if (res.messageType) {
          this.toaster.error(res.message);
        } else {
          this.toaster.success(res.message);
          this.nextRouteName != 'chart-at-glance' &&
            this.sharedService.accessProductSideBarData(() => {});
          if (productName === 'productName') {
            this.sharedService.scenarioNameFunc(
              this.productProjectForm.controls['productName'].value
            );
          }
        }
      });
    }
  }

  commonInputSearch(term: string, item: any) {
    return item.name.toLowerCase().includes(term.toLowerCase());
  }

  findNextRoute() {
    // Get the current productId and current route from the activated route
    const currentProductId = this.productId; // Fetch this from route or localStorage
    const activeIndex = this.menuDataForRouting.findIndex(
      (x: any) => x.description === this.activatedRoute && x.productId === currentProductId
    );

    // Find the next index and route
    const nextIndex = activeIndex + 1;
    if (
      nextIndex < this.menuDataForRouting.length &&
      this.menuDataForRouting[nextIndex].productId === currentProductId
    ) {
      this.nextRouteName = this.menuDataForRouting[nextIndex].description;
    } else {
      this.nextRouteName = 'chart-at-glance'; // No next route
    }
  }

  nextRoute() {
    this.findNextRoute();
    this.showEdit && this.saveData(this.productProjectForm.controls['productName']);
    if (this.nextRouteName == 'chart-at-glance') {
      this.sharedService.accessProductSideBarData('charts');
      this.router.navigate([
        `projects/product-configuration/${customEncode(
          btoa(this.productConfigId)
        )}/chart-at-glance`,
      ]);
    } else {
      const encryptedValue = customEncrypt(this.productId);
      this.router.navigate(
        [
          `projects/product-configuration/${customEncode(btoa(this.productConfigId))}/${
            this.nextRouteName
          }`,
        ],
        { queryParams: { param: encryptedValue } }
      );
    }
  }

  async selectedProductScope(eve: any, item: any) {
    if (item.scopeName?.toLowerCase() === 'ingredients' && !eve.target.checked) {
      eve.preventDefault();
      eve.target.checked = true;
      return;
    }

    // Check if unchecking and data exists
    if (!eve.target.checked) {
      const scopeName = item.scopeName?.toLowerCase();
      let shouldDelete = false;
      let scopeKey: 'manufacturing' | 'productUse' | 'eol' | null = null;

      if (scopeName === 'manufacturing' && this.isProductManufacturingDataDelete) {
        scopeKey = 'manufacturing';
        shouldDelete = true;
      } else if (scopeName === 'product use' && this.isProductUseDataDelete) {
        scopeKey = 'productUse';
        shouldDelete = true;
      } else if (scopeName === 'end-of-life' && this.isProductEOLDataDelete) {
        scopeKey = 'eol';
        shouldDelete = true;
      }

      if (shouldDelete && scopeKey) {
        eve.preventDefault();
        eve.target.checked = true;

        const confirmed = await this.swalService.confirmLegacy({
          title: 'Confirm Delete',
          text: `${item.scopeName} records exist. Do you want to delete them forcefully?`,
          icon: 'warning',
          iconHtml: '',
          confirmButtonText: 'Yes',
          cancelButtonText: 'No',
          showCancelButton: true,
          showConfirmButton: true,
          reverseButtons: true,
          allowOutsideClick: false,
          customClass: 'Popupbackground',
        });

        if (confirmed) {
          this.confirmedDeletes[scopeKey] = true;
          eve.target.checked = false;
        } else {
          return;
        }
      }
    }

    let clone = [...this.productScope];
    clone.forEach((x: any) => {
      if (x.scopeId === item.scopeId) {
        x.checked = eve.target.checked;
      }
    });
    this.productSelected = clone;
    let holdingArr = this.productSelected.filter((z: any) => z.checked == true);
    this.saveCheckboxList = holdingArr;

    if (holdingArr.length >= 1) {
      this.checkBoxValidation = false;
      const payload = {
        productId: this.productId,
        name: this.productProjectForm.controls['productName'].value,
        shortProductName: this.productProjectForm.controls['productNameReport'].value,
        countryId: this.productProjectForm.controls['country'].value?.id,
        productContentsFile: this.selectedFiles,
        productContentsImage: this.fileBase64,
        productScopesSelected: holdingArr,
        description: this.productProjectForm.controls['description'].value,
        amountOfproduct: this.productProjectForm.controls['amount'].value,
        densityOfProduct: this.productProjectForm.controls['density'].value,
        unitId:
          this.productProjectForm.controls['unit'].value?.id ||
          this.allProductConfigurationData?.unitId,
        productConfigId: this.productConfigId,
        isProductManufacturingDataDelete: this.confirmedDeletes.manufacturing,
        isProductUseDataDelete: this.confirmedDeletes.productUse,
        isProductEOLDataDelete: this.confirmedDeletes.eol,
      };
      this.projectService.editProjectProductIngredient(payload).subscribe((res: any) => {
        if (res.messageType == 0) {
          this.toaster.success(res.message);

          // Reset confirmed deletes after successful save
          this.confirmedDeletes = {
            manufacturing: false,
            productUse: false,
            eol: false,
          };

          if (this.nextRouteName == 'chart-at-glance') {
            this.sharedService.accessProductSideBarData('charts');
          } else {
            this.sharedService.accessProductSideBarData(() => {});
          }
        }
      });
    } else {
      this.checkBoxValidation = true;
    }
  }

  // Handle file selection from common component
  onFileSelected(result: FileUploadResult): void {
    if (result.isValid) {
      this.selectedFiles = result.fileName;
      this.fileBase64 = result.fileBase64;
      this.imageUrl = result.fileUrl;

      if (this.fileBase64) {
        this.updateImageForProject();
      }
    }
  }

  // Handle remove confirmation
  handleRemoveConfirmation(): void {
    // If there's a backend image, show confirmation dialog
    if (this.productImage) {
      this.deleteConfirmation();
    } else {
      // If it's just a newly selected file, remove directly
      this.removeImage();
      this.toaster.success('Image has been removed');
    }
  }
  costTurnOff(event: any) {
    this.showCurrencyList = event.target.checked ? true : false;
    this.saveData(event);
  }

  selectCurrency(event: any) {
    if (!event.id) return;
    else {
      this.selectedCurrency = event?.id;
      this.saveData(event);
    }
  }

  async updateImageForProject() {
    const payload = {
      productId: this.productId,
      image: this.fileBase64,
      imageName: this.selectedFiles,
      productConfigId: this.productConfigId,
    };
    const response = await this.projectService.updateProductConfigurationImage(payload);
    this.toaster.success(response.data?.item2);
    this.setFormData();
  }

  removeImage() {
    this.iserror = false;
    this.selectedFiles = null;
    this.fileBase64 = null;
    this.imageUrl = null;
    this.existingFileName = null;
    this.productImage = null;
    // Reset the file upload component if it exists
    if (this.fileUploadComponent) {
      this.fileUploadComponent.reset();
    }
  }

  isIngredientScope(item: any): boolean {
    return item.scopeName?.toLowerCase() === 'ingredients';
  }
}
